// extracted by mini-css-extract-plugin
module.exports =  {"cards":"oLHAySJqeMmd4pfpO6va"};